import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const authParam = new URLSearchParams(window.location.search).get("auth");
    if (authParam) {
      try {
        const auth = JSON.parse(decodeURIComponent(authParam));
        console.log("Decoded auth object:", auth);
        localStorage.setItem("auth", JSON.stringify(auth));
        navigate("/locum-job");
      } catch (err) {
        console.error("Failed to decode auth param", err);
        navigate("/home");
      }
    } else {
      navigate("/home");
    }
  }, [navigate]);

  return null;
};

export default AuthCallback;
